if (!customElements.get('accordion-item')) {
  class AccordionItem extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');

      if (!this.summary || !this.details) {
        return;
      }

      this.summary.addEventListener(
        'click',
        this.handleSummaryClick.bind(this),
      );

      this.summary.setAttribute('role', 'button');
      this.summary.setAttribute(
        'aria-expanded',
        this.details.hasAttribute('open'),
      );

      this.setDummyHeight();

      window.addEventListener('resize', this.setDummyHeight.bind(this));
    }

    setDummyHeight() {
      if (this.querySelector('.accordion__transition-dummy')) {
        this.style.setProperty(
          '--dummy-height',
          `${
            this.summary.offsetHeight -
            this.querySelector('.accordion-extract__title span:not([class]')
              ?.offsetHeight
          }px`,
        );
      }
    }

    handleSummaryClick(event) {
      event.preventDefault();

      if (this.details.open) {
        this.details.classList.remove('is-open');
        this.summary.setAttribute('aria-expanded', false);
        this.closeAnimation(this.details);
        // setTimeout(() => {
        //   this.details.removeAttribute('open');
        //   this.summary.setAttribute('aria-expanded', false);
        // }, 500);
      } else {
        this.details.setAttribute('open', 'true');
        setTimeout(() => {
          this.details.classList.add('is-open');
        }, 50);
        this.summary.setAttribute('aria-expanded', true);
      }
    }

    closeAnimation(detailsElement) {
      let animationStart;

      const handleAnimation = (time) => {
        if (animationStart === undefined) {
          animationStart = time;
        }

        const elapsedTime = time - animationStart;

        elapsedTime < 400
          ? window.requestAnimationFrame(handleAnimation)
          : detailsElement.removeAttribute('open');
      };

      window.requestAnimationFrame(handleAnimation);
    }
  }
  customElements.define('accordion-item', AccordionItem);
}
